var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 32C41.433 32 43 30.433 43 28.5C43 26.567 41.433 25 39.5 25C37.567 25 36 26.567 36 28.5C36 30.433 37.567 32 39.5 32Z",
    fill: "#3DE8CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3 29.34C27.52 29.65 32.75 36.98 39.52 36.98C46.28 36.98 51.52 29.67 51.75 29.34C51.9259 29.0858 52.0201 28.7841 52.0201 28.475C52.0201 28.1659 51.9259 27.8641 51.75 27.61C51.7455 27.6039 51.739 27.595 51.7306 27.5836C51.3131 27.014 46.1564 19.98 39.52 19.98C32.75 19.98 27.52 27.3 27.3 27.61C27.12 27.8625 27.0232 28.1649 27.0232 28.475C27.0232 28.7851 27.12 29.0875 27.3 29.34ZM39.52 33.98C35.52 33.98 31.86 30.23 30.43 28.47L30.41 28.49C31.86 26.75 35.49 22.98 39.52 22.98C43.55 22.98 47.16 26.74 48.62 28.48C47.17 30.22 43.52 33.98 39.52 33.98Z",
    fill: "#3DE8CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5 8C28.1782 8 19 17.1782 19 28.5C19 33.621 20.8777 38.3035 23.9823 41.8964L15.4393 50.4393C14.8536 51.0251 14.8536 51.9749 15.4393 52.5607C16.0251 53.1464 16.9749 53.1464 17.5607 52.5607L26.1036 44.0177C29.6965 47.1223 34.379 49 39.5 49C50.8218 49 60 39.8218 60 28.5C60 17.1782 50.8218 8 39.5 8ZM22 28.5C22 18.835 29.835 11 39.5 11C49.165 11 57 18.835 57 28.5C57 38.165 49.165 46 39.5 46C29.835 46 22 38.165 22 28.5Z",
    fill: "#3DE8CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.5C13 12.6716 13.6716 12 14.5 12H18.5C19.3284 12 20 12.6716 20 13.5C20 14.3284 19.3284 15 18.5 15H14.5C13.6716 15 13 14.3284 13 13.5Z",
    fill: "#3DE8CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 20C7.67157 20 7 20.6716 7 21.5C7 22.3284 7.67157 23 8.5 23H14.5C15.3284 23 16 22.3284 16 21.5C16 20.6716 15.3284 20 14.5 20H8.5Z",
    fill: "#3DE8CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 28C3.67157 28 3 28.6716 3 29.5C3 30.3284 3.67157 31 4.5 31H12.5C13.3284 31 14 30.3284 14 29.5C14 28.6716 13.3284 28 12.5 28H4.5Z",
    fill: "#3DE8CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEye);
export default __webpack_public_path__ + "static/media/search-eye.83b5e5fe4eabda787ec1be2dde49a332.svg";
export { ForwardRef as ReactComponent };